import * as api from 'helpers/api';

const rootPath = '/research/comp_reports';

export const createReport = (params) => {
  return api.post(rootPath, params);
};
